import base64 from 'base-64';
import { decompress } from 'lzutf8';

const username = 'admin';
const password = 'admin';
const host = process.env.NODE_ENV !== 'development' ? '' : 'http://localhost:8080';

const customFetch = (url, options = {}) => {
  const headers = options.headers || {};

  options.headers = headers;
  options.credentials = 'include';
  options.mode = 'cors';

  headers.Authorization = `Basic ${base64.encode(`${username}:${password}`)}`;
  headers['Content-type'] = 'application/json; charset=UTF-8';
  headers.Accept = 'application/json, text/plain, */*';

  return fetch(`${host}${url}`, options);
};

const moveBlocks = (selector, prefix, maxHeightPlace, onScroll) => {
  if (document.querySelector && document.querySelectorAll) {
    const sumHeight = 0;
    let blockWidth = document.querySelector(selector)
      ? document.querySelector(selector).offsetWidth : window.innerWidth;

    let count = 4;
    if (blockWidth > 4 * 336) {
      count = 4;
    } else if (blockWidth > 3 * 336) {
      count = 3;
    } else if (blockWidth > 2 * 336) {
      count = 2;
    } else {
      count = 1;
    }
    blockWidth /= count;
    blockWidth -= 30;
    blockWidth = Math.round(blockWidth);

    let sumHeightPlace = 0;
    const topPlace = [];
    const leftPlace = [];
    const widthPlace = [];
    [].forEach.call(document.querySelectorAll(`${selector} .bi`), (el) => {
      sumHeightPlace += el.offsetHeight;
    });
    if (sumHeightPlace && sumHeightPlace / count === maxHeightPlace) {
      document.getElementById('root').classList.add('loaded');
      requestAnimationFrame(() => {
        document.getElementById('splash').classList.add('loaded');
        requestAnimationFrame(() => {
          if (onScroll) {
            onScroll(3);
          }
        });
      });
    }
    maxHeightPlace = sumHeightPlace / count;
    let currentLeftPlace = 0;
    let currentTopPlace = 0;
    sumHeightPlace = 0;
    [].forEach.call(document.querySelectorAll(`${selector} .bi`), (el, i) => {
      const ad = el.querySelector('ins');
      topPlace[i] = Math.round(currentTopPlace);
      if (ad) {
        widthPlace[i] = ad.offsetWidth;
        leftPlace[i] = Math.round(currentLeftPlace + ((blockWidth - ad.offsetWidth) / 2));
      } else {
        widthPlace[i] = blockWidth;
        leftPlace[i] = Math.round(currentLeftPlace);
      }
      currentTopPlace += el.offsetHeight + 30;
      if (currentTopPlace > sumHeightPlace) {
        sumHeightPlace = currentTopPlace + 15;
      }
      if (currentTopPlace > maxHeightPlace
        && currentLeftPlace + el.offsetWidth < blockWidth * count) {
        currentTopPlace = 0;
        currentLeftPlace += blockWidth + 30;
      }
    });
    const data = {
      sumHeight,
    };
    data[`${prefix}Top`] = topPlace;
    data[`${prefix}Left`] = leftPlace;
    data[`${prefix}Width`] = widthPlace;
    data[`${prefix}SumHeight`] = sumHeightPlace;
    data[`${prefix}MaxHeightPlace`] = maxHeightPlace;
    return data;
  }
  return {};
};

const isBrowser = () => {
  try {
    return !!window.navigator;
  } catch (e) {
    return false;
  }
};

const getData = () => {
  const dataBSON = isBrowser() && window.data;
  let data = null;
  if (dataBSON) {
    data = JSON.parse(decompress(dataBSON, {
      inputEncoding: 'Base64',
    }));
  }
  return data;
};

export {
  customFetch as fetch, moveBlocks, isBrowser, getData,
};
